import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
/* global bootstrap */
import BackButton from "../components/BackButton";
// import apple from '../assets/icons8-apple-50.png'
// import google from '../assets/icons8-google-play-48.png'
// import huwaei from '../assets/icons8-huawei-48.png'

export default function Settings() {

  const [iframeUrl, setIframeUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [country, setCountry] = useState();

  const [user, setUser] = useState([])

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('GF_User_Data')))
    setCountry(sessionStorage.getItem("Country"))
  }, [])

  const settingsItems = [

    // ...(user.ShowAccountDetails ? [{
    //   label: "Account Details",
    //   url: `https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`,
    //   key: "accountDetails",
    // }] : []),

    // ...(user.showUnsib ? [{
    //   label: "Unsubscribe",
    //   url: `https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`,
    //   key: "unsubscribe",
    // }] : []),

    {
      label: "Account Details",
      url: `https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`,
      key: "accountDetails",
    },
    
  ...(
    country !== 'CH'
      ? [{
          label: "Unsubscribe",
          url: `https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`,
          key: "unsubscribe",
        }]
      : []
  ),

    {
      label: "Terms And Conditions",
      url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/Terms%26Conditions.html?service=gamesfort",
      key: "terms",
    },
    {
      label: "Privacy Policy",
      url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/PrivacyPolicy.html?service=gamesfort",
      key: "privacy",
    }
  ];


  const [os, setOs] = useState("");

  useEffect(() => {
    const getOS = () => {
      const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        return "android";
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
      }

      if (/huawei/i.test(userAgent) || /honor/i.test(userAgent)) {
        return "huawei";
      }

      return "web";
    };

    setOs(getOS());
  }, []);



  const handleOpen = (item) => {
    setIframeUrl(item.url);
    setModalTitle(item.label);
    const offcanvas = new bootstrap.Offcanvas('#settingsOffcanvas');
    offcanvas.show();
  };

  return (

    <div>

      <Sidebar />
      <div className="main-body">
        <BackButton />
        <h4 className='my-3' ><strong>Settings</strong></h4>
        <div className="d-flex flex-column gap-2 mt-4">
          {settingsItems.map((item) => (
            <button
              key={item.key}
              className={`btn btn-settings text-start`}
              onClick={() => handleOpen(item)}
            >
              {item.label}
            </button>
          ))}


          {/* <div className={`btn btn-settings text-start d-flex flex-column align-items-start gap-3`}  >
            Get to your games faster using our Web App. Installing requires almost no storage

            {os === "ios" && (
              <a className='os-button' href='https://apps.apple.com/app/id1495934439' target='_blank'>
                <img src={apple} />
                <div className='os-button-text'>
                  <span>Available in the</span>
                  <p>App Store</p>
                </div>
              </a>
            )}

            {os === "android" && (
              <a className='os-button' href='https://play.google.com/store/apps/details?id=games.enjoy.box' target='_blank'>
                <img src={google} />
                <div className='os-button-text'>
                  <span>Get it on</span>
                  <p>Google Play</p>
                </div>
              </a>
            )}

            {os === "huawei" && (
              <a className='os-button  btn btn-primary' href='https://appgallery.huawei.com/#/app/C106192495' target='_blank'>
                <img src={huwaei} />
                <div className='os-button-text'>
                  <span>Explore it on</span>
                  <p>AppGallery</p>
                </div>
              </a>
            )}

            {os === "web" && (
              <>
                <a className='os-button' href='https://apps.apple.com/app/id1495934439' target='_blank'>
                  <img src={apple} />
                  <div className='os-button-text'>
                    <span>Available in the</span>
                    <p>App Store</p>
                  </div>
                </a>

                <a className='os-button' href='https://play.google.com/store/apps/details?id=games.enjoy.box' target='_blank'>
                  <img src={google} />
                  <div className='os-button-text'>
                    <span>Get it on</span>
                    <p>Google Play</p>
                  </div>
                </a>

                <a className='os-button' href='https://appgallery.huawei.com/#/app/C106192495' target='_blank'>
                  <img src={huwaei} />
                  <div className='os-button-text'>
                    <span>Explore it on</span>
                    <p>AppGallery</p>
                  </div>
                </a>
              </>
            )}


          </div> */}


        </div>

        {/* Bootstrap Offcanvas */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="settingsOffcanvas"
          aria-labelledby="offcanvasLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasLabel">{modalTitle}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body p-0">
            {iframeUrl && (
              <iframe
                src={iframeUrl}
                title={modalTitle}
                style={{ width: "100%", height: "100%", border: "none", minHeight: "80vh" }}
              />
            )}
          </div>
        </div>
      </div>
    </div>

  );
}
